import React, { FC } from 'react';

import { Link, Text } from '@nord/ui';

import permissionsIcon from '../assets/img/permissions-icon.svg';
import NoItems from '../molecules/NoItems';
import { IPublicContainerProps } from '../templates/PublicContainer';
import TwoColView from '../templates/TwoColView';

interface IComp403 extends IPublicContainerProps {
  email?: string;
}

const Forbidden: FC<IComp403> = ({ email, ...rest }) => (
  <TwoColView withoutImage {...rest}>
    <NoItems
      icon={permissionsIcon}
      iconTitle="No permission to access"
      useSVG={false}
      text={
        <>
          <Text variant="body2" className="pb-4">
            Missing permissions
          </Text>
          <Text variant="body2">
            In order to get a permission, contact your administrator{' '}
            {!!email && (
              <Link className="block text-blue font-medium mt-2" href={`mailto:${email}`}>
                {email}
              </Link>
            )}
          </Text>
        </>
      }
    />
  </TwoColView>
);

export default Forbidden;
